import { createFileRoute, Link } from "@tanstack/react-router";
import { AuthCard } from "@/components/auth-card";
import { ApplyForm } from "@/features/reseller/apply/form";
import { m } from "@/lib/paraglide/messages.js";

export const Route = createFileRoute("/(public)/apply")({
  component: () => (
    <AuthCard
      title={m.apply_title()}
      description={m.apply_description()}
      footer={
        <>
          {m.apply_have_account()} <Link to="/login">{m.common_sign_in()}</Link>
        </>
      }
    >
      <ApplyForm />
    </AuthCard>
  ),
});
